import styled from '@emotion/styled'
export const StyleEmptyWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: ${(props) => (props.isMobile ? 'calc(100vh - 184px)' : 'auto')};
`

export const StyleEmptyTitle = styled.p`
  font-size: 18px;
  text-align: center;
  font-weight: 400;
  color: ${(props: any) => props.theme.colors.borderColor};
  margin-top: 10px;
`
export const StyleEmptyDescription = styled.p`
  font-size: 14px;
  text-align: center;
  color: ${(props: any) => props.theme.colors.borderColor};
  margin-top: 10px;
`
